<template>
    <div class="login">
        <img class="logo" src="../../assets/images/logo.png" alt="">
        <h2 class="projectName">{{ config.name }}{{ isStore ? '商家端' : '运营' }}</h2>
        <p class="projectDescribe">{{ config.slogan }}</p>
        <p class="inputTag">用户名</p>
        <input type="text" class="input" ref="username" v-model="username" placeholder="请输入用户名/手机号" />
        <p class="inputTag">密码</p>
        <input type="password" class="input" ref="password" v-model="password" placeholder="请输入密码" />
        <div class="btn" @click="onLogin">
            <span>登录</span>
        </div>
        <div class="forget">
            <router-link to="/forgetPS">忘记密码？</router-link>
        </div>
        <div class="agreement">
            <div class="agree" @click="onAgree">
                <span :class="{ active: isAgree }"></span>
                <p @click.stop="onAgreeHtml">阅读并且同意《使用协议》</p>
            </div>
            <p>copyright {{ config.name }}</p>
        </div>
    </div>
</template>

<script>
/*
* 登录
* */
import config from '../../Config';
import { mapState } from 'vuex';
import { getPublicKey, login } from '../../api/login';
export default {
    name: "login",
    data() {
        return {
            config,
            isAgree: true,
            username: '',
            password: '',
            reg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            publicKey: ''
        }
    },
    computed: {
        ...mapState(['isStore'])
    },
    mounted() {
        this.getPublicKey();
    },


    methods: {
        getPublicKey() {
            getPublicKey().then((res) => {
               
                this.publicKey = res;
                localStorage.setItem("publicKey", this.publicKey);
            });

        },
        onAgree() {
            this.isAgree = !this.isAgree;
        },
        onAgreeHtml() {
            window.open(this.config.agreementUrl, '_blank');
        },
        onLogin() {
            // window.localStorage.setItem("username",this.username)
            // window.localStorage.setItem("password",this.password)

            let { isAgree, username, password } = this;
            if (!isAgree) return this.toast({ text: '请确认阅读并同意《使用协议》', icon: 'warning' });
            if (!username) return this.toast({ text: '请输入用户名', icon: 'warning' });
            if (!password) return this.toast({ text: '请输入密码', icon: 'warning' });
            if (!this.publicKey) {
                this.getPublicKey();
            }
            this.$store.dispatch('login', { username, password }).then(result => {

                let { levelCode } = result;
                console.log(result)
                if (!this.isStore && levelCode === "F") return this.toast({
                    text: '商家禁止在运营端登录',
                    icon: 'warning'
                });
                if (this.isStore && levelCode !== "F") return this.toast({
                    text: '代理禁止在商家端登录',
                    icon: 'warning'
                });
                this.$store.dispatch('getUserInfo').then(_ => {
                    this.toPage(this.isStore ? '/home' : '/mine', true);
                });


            })
        }
    }

}
</script>

<style scoped>
.login {
    position: relative;
    padding: 5vw 11vw 17vw;
    min-height: 100vh;
    box-sizing: border-box;
}

.logo {
    display: block;
    width: 20vw;
    height: 20vw;
}

.projectName {
    margin: 5.8vw 0 2.8vw;
    font-size: 7vw;
    color: #333333;
}

.projectDescribe {
    margin-bottom: 9vw;
    font-size: 4vw;
    color: #999999;
}

.inputTag {
    font-size: 4vw;
    line-height: 8vw;
    color: #333333;
}

.input {
    display: block;
    width: 79vw;
    height: 11vw;
    padding: 3vw;
    margin-bottom: 4vw;
    border-radius: 5vw;
    border: solid 0.5px #ebebeb;
    box-sizing: border-box;
    outline: none;
    font-size: 3vw;
    -webkit-appearance: none;
    -webkit-user-select: auto;
}

.input::placeholder {
    color: #dbdbdb;
}

.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 79vw;
    height: 11vw;
    margin-top: 13vw;
    font-size: 5vw;
    color: #ffffff;
    background-image: linear-gradient(90deg,
            #31a2fe 0%,
            #4ca8f3 100%),
        linear-gradient(#ff6a49,
            #ff6a49);
    background-blend-mode: normal,
        normal;
    box-shadow: 0vw 1vw 3vw 0vw rgba(49, 162, 254, 0.39);
    border-radius: 5vw;
}

.forget {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 23vw;
}

.forget a {
    font-size: 4vw;
    color: #bbbbbb;
}

.agreement {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 17vw;
}

.agree {
    display: flex;
    align-items: center;
    font-size: 3vw;
    color: #1a1b1d;
}

.agree span {
    width: 3vw;
    height: 3vw;
    margin-right: 2vw;
    border: 0.5px solid #bbbbbb;
    border-radius: 50%;
    box-sizing: border-box;
}

.agree span.active {
    border: none;
    background: url("../../assets/images/ic_active.png") 0 0 no-repeat;
    background-size: 100% 100%;
}

.agreement p {
    font-size: 3vw;
    color: #1a1b1d;
}
</style>



// WEBPACK FOOTER //
// src/page/login/Login.vue